import script from "./KSMarketData.vue?vue&type=script&setup=true&lang=js"
export * from "./KSMarketData.vue?vue&type=script&setup=true&lang=js"

import "./KSMarketData.vue?vue&type=style&index=0&id=a4aa3a60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4aa3a60"]])

export default __exports__